import { highLevelApi } from '@sdk/main'

export function track(payload: { event_name: string; payload: any }) {
  return highLevelApi.API.request('track', payload)
}
